<template>
  <v-container fluid>

    <v-layout row flex align-center justify-center>
      <v-flex xs12 sm6 pt-5 >
        <v-card>
          <v-card-media v-if="logoApp" :src="logoApp" height="120px" contain>
          </v-card-media>
          <v-card-text>
            <v-container grid-list-md>
              <h1 class="display-1 text-xs-center">Dados de Acesso</h1>
              <v-card class="pa-2 my-2 grey lighten-5" flat>
                <h1 class="headline primary--text">Paciente: <b>{{resultado.nomePaciente}}</b></h1>
                <h3 class="subheading primary--text">Exame: <b>{{resultado.tipoExame}} - {{resultado.modalidade}}</b></h3>

              </v-card>

              <v-form ref="form" v-on:submit.prevent v-model="valid" >
              <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-text-field
                            label="CPF"
                            required
                            v-on:keyup.enter="buscarUsuario"
                            v-model="resultado.cpfPaciente"
                            v-mask="['###.###.###-##']"                            
                            @change="buscouCPF = false"
                            :rules="[validarMinimo(resultado.cpfPaciente, 14), obrigatorioRules[0]]"
                            ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                            v-if="buscouCPF"
                            label="Email"
                            v-model="usuario.email"
                            type="username"
                            :rules="emailRules"
                            ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                      <v-text-field
                              label="Login"
                              :disabled="true"
                              v-if="buscouCPF"
                              v-model="usuario.username"
                              type="username"
                              :persistent-hint='true'
                              hint="Login será os números do CPF"
                              required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                      <v-text-field
                              label="Senha"
                              v-if="buscouCPF"
                              v-model="usuario.password"
                              required
                              :rules="obrigatorioRules"
                              :append-icon="esconderSenha ? 'visibility' : 'visibility_off'"
                              :append-icon-cb="() => (esconderSenha = !esconderSenha)"
                              :type="esconderSenha ? 'password' : 'text'"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                            v-if="buscouCPF"
                            label="Celular (whatsapp)"
                            v-model="resultado.telefonePaciente"
                            type="username"
                            v-mask="['(##) #####-####']"
                            placeholder="(##) #####-####"
                            :rules="[validarMinimo(resultado.telefonePaciente, 15)]"
                            hint="Informe o número do whatsapp"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-checkbox v-if="buscouCPF"  label="Autoriza o envio por Whatsapp" :disabled="!whatsapp" color="green" v-model="resultado.whatsapp"></v-checkbox>
                  </v-flex>

                  <v-flex xs12 sm6>
                    <v-checkbox v-if="buscouCPF"  label="Autoriza o envio por E-mail" :disabled="!usuario.email" color="green" v-model="resultado.enviaEmail"></v-checkbox>
                  </v-flex>

                </v-layout>

                <v-layout row>
                  <v-spacer></v-spacer>
                    <v-btn color="" @click="limpar">limpar</v-btn>
                    <v-btn v-if="!buscouCPF" color="primary" :disabled="!valid" v-on:click.prevent="buscarUsuario()">continuar</v-btn>
                    <v-btn v-if="buscouCPF" color="primary" :disabled="!valid" v-on:click.prevent="atualizar()">{{tituloBotaoSubmit}}</v-btn>
                    <v-btn v-if="buscouCPF && resultado.usuario && resultado.usuario.id"  color="primary" @click="print">visualizar impressão</v-btn>
                    <v-btn v-if="buscouCPF && resultado.usuario && resultado.usuario.id"  color="primary" @click="sendMail">enviar por email</v-btn>

                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-snackbar
      :timeout="timeoutAlerta"
      :color="tipoAlerta"
      v-model="snackbar">
      {{ textAlerta }}
      <v-btn dark flat @click.native="snackbar = false">Fechar</v-btn>
    </v-snackbar>

  </v-container>
</template>

<script>

import axios from 'axios'
import moment from 'moment'

moment.locale('pt-BR')

export default {
  name: 'cartao-acesso',
  data () {
    return {
      esconderSenha: false,
      cabecalho: {},
      usuario: {},
      resultado: {},
      titulo: 'Dados de Acesso',
      buscouCPF: false,
      emailRules: [
        value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return (!value || pattern.test(value)) || 'E-mail deve ser válido'
        }
      ],
      obrigatorioRules: [
        v => !!v || 'Campo obrigatório'
      ],
      valid: false,
      snackbar: false,
      whatsapp: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: ''
    }
  },
  components: {
  },
  computed: {
    logoApp () {
      return this.$store.state.cabecalho.logo
    },
    cpfLimpo () {
      if (this.resultado.cpfPaciente) {
        return this.resultado.cpfPaciente.replace(/\./g, '').replace('-', '')
      }
    },
    tituloBotaoSubmit () {
      return this.usuario.id ? 'Atualizar Usuário' : 'Criar Usuário'
    }
  },
  watch: {
    resultado: {
      handler: function (val) {
        if (!val.cpfPaciente || !val.telefonePaciente) {
          this.whatsapp = false
          val.whatsapp = false
        }
      },
      deep: true
    },
    valid: function () {
      if (!this.valid) {
        this.whatsapp = false
        console.log(this.whatsapp)
        this.resultado.whatsapp = false
      } else if (this.resultado.cpfPaciente && this.resultado.telefonePaciente) {
        this.whatsapp = true
      }
    }
  },
  methods: {
    moment (data) {
      return moment(data)
    },
    validarMinimo (valor, minimo) {
      let valido = valor == null || valor === ''
      return !valido && valor.length < minimo ? 'Campo inválido' : true
    },
    limparSelecao () {
      console.log(this.pagination)
    },
    detectmob () {
      if (navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)) {
        return true
      } else {
        return false
      }
    },
    buscarResultado () {
      var params = `resultado=${this.$route.params.resultado}`
      var self = this
      axios.get(`/cartaoAcesso?${params}`)
        .then(response => {
          console.log(response.data.usuario.id)
          self.resultado = response.data.resultado
          self.usuario = response.data.usuario
          self.buscouCPF = response.data.usuario.id != null
          console.log(self.buscouCPF)
          self.$store.commit('changeMenu', {
            r: this.resultado.id
          })
        })
        .catch(e => {
          console.log(e.response.status)
          self.$router.push({name: 'NotFound'})
        })
    },
    buscarUsuario () {
      if (this.$refs.form.validate()) {
        var self = this
        axios.get(`/cartaoAcesso/usuario/${this.cpfLimpo}`)
          .then(response => {
            self.usuario = response.data.usuario
            self.resultado.telefonePaciente = response.data.usuario.telefone
            self.buscouCPF = true
          })
          .catch(e => {
            console.log(e.response.status)
          })
      }
    },
    limpar () {
      this.buscarResultado()
    },
    print () {
      let link = `${axios.defaults.baseURL}/cartaoAcesso/${this.resultado.id}?access_token=${window.localStorage.getItem('token')}`
      console.log(link)
      window.open(link)
    },
    atualizar () {
      if (this.$refs.form.validate()) {
        var self = this
        this.usuario.cpf = this.cpfLimpo
        var model = {
          resultado: this.resultado,
          usuario: this.usuario
        }
        axios.put(`/cartaoAcesso/${this.resultado.id}`, model)
          .then(function (response) {
            self.resultado = response.data.resultado
            self.usuario = response.data.usuario
            self.resultado = response.data.resultado
            self.tipoAlerta = 'success'
            self.textAlerta = 'Cartão de acesso atualizado com sucesso'
            self.snackbar = true
          })
          .catch(e => {
            self.tipoAlerta = 'error'
            self.textAlerta = 'Erro ao atualizar cartão de acesso'
            self.snackbar = true
          })
      }
    },
    sendMail () {
      console.log('email cartao')
      var self = this
      axios.post(`/emailCartao`, {id: this.resultado.id})
        .then(function (response) {
          console.log(response)
          self.tipoAlerta = 'success'
          self.textAlerta = 'E-mail enviado com sucesso'
          self.snackbar = true
          self.dialog = false
        })
        .catch(e => {
          self.tipoAlerta = 'error'
          self.textAlerta = 'Ocorreu um erro ao enviar cartão de acesso.'
          self.snackbar = true
        })
    }
  },
  created () {
    this.buscarResultado()
  },
  mounted () {
    this.$refs.form.validate()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// CartaoAcesso.vue?2a98391c